<ng-container *transloco="let t">
    @let calendars = calendars$ | async;
    @if (calendars) {
        <div class="bazis-datepicker">
            @for (calendar of calendars; track $index; let calendarIndex = $index) {
                <div class="bazis-calendar">
                    <div
                        class="bazis-calendar__head"
                        [class.bazis-calendar__head_left]="
                            allViewConfig.typeHeadCalendar === 'left'
                        "
                        part="calendar-head"
                    >
                        @if (allViewConfig.typeHeadCalendar === 'center') {
                            <bazis-button
                                [hidden]="!calendar.isFirst"
                                [part]="
                                    calendarsNumber() > 1
                                        ? 'button head-button interval-head-button'
                                        : 'button head-button'
                                "
                                [ngClass]="{
                                    'bazis-calendar__btn': true,
                                    'bazis-calendar__btn_interval': calendarsNumber() > 1,
                                }"
                                [fill]="calendarsNumber() > 1 ? 'outline' : 'clear'"
                                [disabled]="calendar.disabledPrevMonth"
                                (click)="stepPrevMonth()"
                            >
                                <bazis-icon
                                    slot="icon-only"
                                    [icon]="allViewConfig.iconLeft"
                                ></bazis-icon>
                            </bazis-button>
                        }
                        <div
                            class="bazis-calendar__value"
                            part="value"
                        >
                            <div class="bazis-dropdown">
                                @if (
                                    allViewConfig.typeSelectMonth === 'list' ||
                                    monthListOpened !== calendarIndex
                                ) {
                                    <div
                                        class="bazis-dropdown__trigger"
                                        (click)="toogleMonthList(calendarIndex)"
                                    >
                                        {{ t('months.long.' + monthNames[calendar.calendarMonth])
                                        }}{{ allViewConfig.valueMonthWithComma ? ',' : '' }}
                                    </div>
                                }
                                @if (allViewConfig.typeSelectMonth === 'list') {
                                    <div
                                        class="bazis-dropdown__body"
                                        [hidden]="monthListOpened !== calendarIndex"
                                    >
                                        <ul
                                            class="bazis-list"
                                            part="list"
                                        >
                                            @for (month of calendar.monthList; track $index) {
                                                <li
                                                    class="bazis-item"
                                                    part="list-item"
                                                    [ngClass]="{
                                                        'bazis-item--selected': month.isCurrent,
                                                        'bazis-item--disabled': month.isMuted,
                                                    }"
                                                    (click)="
                                                        changeCurrentMonth(month);
                                                        toogleMonthList(calendarIndex)
                                                    "
                                                >
                                                    <span>
                                                        {{
                                                            t(
                                                                'months.' +
                                                                    allViewConfig.typeValueMonth +
                                                                    '.' +
                                                                    month.name
                                                            )
                                                        }}</span
                                                    >
                                                </li>
                                            }
                                        </ul>
                                    </div>
                                }
                            </div>
                            <div class="bazis-dropdown">
                                <div
                                    class="bazis-dropdown__trigger"
                                    (click)="toogleYearsList(calendarIndex)"
                                >
                                    {{ calendar.calendarYear }}
                                </div>
                                <div
                                    class="bazis-dropdown__body"
                                    [hidden]="yearsListOpened !== calendarIndex"
                                >
                                    <!-- <bazis-button
                                part="button"
                                class="bazis-calendar__btn"
                                fill="clear"
                                [disabled]="calendar.disabledPrevYear"
                                (click)="stepPrevYear()"
                            >
                                <bazis-icon
                                    slot="icon-only"
                                    name="angle-small-up"
                                ></bazis-icon>
                            </bazis-button> -->
                                    <ul
                                        class="bazis-list"
                                        part="list list-year"
                                        #listYear
                                    >
                                        @for (year of calendar.yearList; track $index) {
                                            <li
                                                class="bazis-item"
                                                part="list-item"
                                                [ngClass]="{
                                                    'bazis-item--selected': year.isCurrent,
                                                    'bazis-item--disabled': year.isMuted,
                                                }"
                                                [id]="year.isCurrent ? 'yearSelected' : ''"
                                                (click)="
                                                    changeCurrentYear(year.id);
                                                    toogleYearsList(calendarIndex)
                                                "
                                            >
                                                <span>{{ year.id }}</span>
                                            </li>
                                        }
                                    </ul>
                                    <!-- <bazis-button
                                part="button"
                                class="bazis-calendar__btn"
                                fill="clear"
                                [disabled]="calendar.disabledNextYear"
                                (click)="stepNextYear()"
                            >
                                <bazis-icon
                                    slot="icon-only"
                                    name="angle-small-down"
                                ></bazis-icon>
                            </bazis-button> -->
                                </div>
                            </div>
                        </div>

                        <div class="bazis-calendar__head__buttons">
                            @if (allViewConfig.typeHeadCalendar === 'left') {
                                <bazis-button
                                    [hidden]="!calendar.isFirst"
                                    [part]="
                                        calendarsNumber() > 1
                                            ? 'button head-button interval-head-button'
                                            : 'button head-button'
                                    "
                                    [ngClass]="{
                                        'bazis-calendar__btn': true,
                                        'bazis-calendar__btn_interval': calendarsNumber() > 1,
                                    }"
                                    [fill]="calendarsNumber() > 1 ? 'outline' : 'clear'"
                                    [disabled]="calendar.disabledPrevMonth"
                                    (click)="stepPrevMonth()"
                                >
                                    <bazis-icon
                                        slot="icon-only"
                                        [icon]="allViewConfig.iconLeft"
                                    ></bazis-icon>
                                </bazis-button>
                            }
                            @if (calendar.isLast) {
                                <bazis-button
                                    [part]="
                                        calendarsNumber() > 1
                                            ? 'button head-button interval-head-button'
                                            : 'button head-button'
                                    "
                                    [ngClass]="{
                                        'bazis-calendar__btn': true,
                                        'bazis-calendar__btn_interval': calendarsNumber() > 1,
                                    }"
                                    [fill]="calendarsNumber() > 1 ? 'outline' : 'clear'"
                                    [disabled]="calendar.disabledNextMonth"
                                    (click)="stepNextMonth()"
                                >
                                    <bazis-icon
                                        slot="icon-only"
                                        [icon]="allViewConfig.iconRight"
                                    ></bazis-icon>
                                </bazis-button>
                            }
                        </div>
                    </div>
                    <div
                        class="bazis-calendar__body"
                        part="calendar-body"
                    >
                        @if (
                            allViewConfig.typeSelectMonth !== 'grid' ||
                            monthListOpened !== calendarIndex
                        ) {
                            <table class="bazis-calendar__table">
                                <thead part="thead">
                                    <tr>
                                        @for (dayNameShort of weekDaysNamesShort; track $index) {
                                            <th class="bazis-calendar__weekday">
                                                {{ t('weekDays.short.' + dayNameShort) }}
                                            </th>
                                        }
                                    </tr>
                                </thead>
                                <tbody>
                                    @for (row of calendar.daysMatrix; track $index) {
                                        <tr>
                                            @for (date of row; track $index) {
                                                @if (date.isValid) {
                                                    <td
                                                        class="bazis-calendar__day"
                                                        [ngClass]="{
                                                            'bazis-calendar__day_current':
                                                                date.isToday,
                                                            'bazis-calendar__day--selected':
                                                                date.isSelected,
                                                            'bazis-calendar__day--muted':
                                                                date.isMuted,
                                                            'bazis-calendar__day_interval':
                                                                date.isInInterval,
                                                            'bazis-calendar__day_interval_last':
                                                                date.isInIntervalLast,
                                                            'bazis-calendar__day_interval_first':
                                                                date.isInIntervalFirst,
                                                            'bazis-calendar__day_weekend':
                                                                date.isWeekend,
                                                        }"
                                                        (click)="
                                                            handleDayClick(
                                                                date,
                                                                calendar.calendarYear,
                                                                calendar.calendarMonth
                                                            )
                                                        "
                                                    >
                                                        <span>{{ date.dayNumber }}</span>
                                                        @if (date.mark) {
                                                            <span
                                                                [part]="
                                                                    'mark ' +
                                                                    date.mark +
                                                                    (date.isSelected
                                                                        ? ' active'
                                                                        : '')
                                                                "
                                                                class="bazis-calendar__day__mark"
                                                                [class]="
                                                                    'bazis-calendar__day__mark--' +
                                                                    date.mark
                                                                "
                                                            >
                                                            </span>
                                                        }
                                                    </td>
                                                } @else {
                                                    <td></td>
                                                }
                                            }
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        }
                        @if (
                            allViewConfig.typeSelectMonth === 'grid' &&
                            monthListOpened === calendarIndex
                        ) {
                            <div class="bazis-calendar__grid bazis-list">
                                @for (month of calendar.monthList; track $index) {
                                    <div
                                        class="bazis-item"
                                        [part]="
                                            'grid-item' +
                                            (month.isCurrent ? ' selected' : '') +
                                            (month.isMuted ? ' disabled' : '')
                                        "
                                        [ngClass]="{
                                            'bazis-item--selected': month.isCurrent,
                                            'bazis-item--disabled': month.isMuted,
                                        }"
                                        (click)="
                                            changeCurrentMonth(month);
                                            toogleMonthList(calendarIndex)
                                        "
                                    >
                                        <span>
                                            {{
                                                t(
                                                    'months.' +
                                                        allViewConfig.typeValueMonth +
                                                        '.' +
                                                        month.name
                                                )
                                            }}</span
                                        >
                                    </div>
                                }
                            </div>
                        }
                    </div>
                    <div
                        class="bazis-calendar__foot"
                        part="calendar-foot"
                    >
                        <div class="bazis-btn-group">
                            @if (resetBtn().use) {
                                <bazis-button
                                    part="button"
                                    class="bazis-calendar__btn"
                                    (click)="clear()"
                                >
                                    {{ resetBtn().txt }}
                                </bazis-button>
                            }
                            @if (currentDateBtn().use) {
                                <bazis-button
                                    part="button"
                                    class="bazis-calendar__btn"
                                    (click)="selectTodayDay()"
                                >
                                    {{ currentDateBtn().txt || '' }}
                                </bazis-button>
                            }
                        </div>
                        @if (additionalBtns()) {
                            <div class="bazis-btn-group">
                                @for (additionalBtn of additionalBtns(); track $index) {
                                    <bazis-button
                                        part="button"
                                        class="bazis-calendar__btn"
                                        (click)="additionalBtn.clickFn()"
                                    >
                                        {{ additionalBtn.txt }}
                                    </bazis-button>
                                }
                            </div>
                        }
                    </div>
                </div>
            }
            <div
                class="bazis-datepicker__backdrop"
                [hidden]="!(monthListOpened || yearsListOpened)"
                (click)="closeLists()"
            ></div>
        </div>
    }
</ng-container>
@let updateMonth = updateMonth$ | async;
@let updateYear = updateYear$ | async;
@let updateStartCalendar = updateStartCalendar$ | async;
